<template>
  <div
    data-testid="MappedLocation"
    :class="{
      'border border-solid border-www-color-accent-soft bg-www-color-accent-almost-white': true,
    }"
  >
    <ScriptGoogleMaps
      v-if="location && location.lat && location.lng"
      :center="{ lat: location.lat, lng: location.lng }"
      :zoom="location.alt"
      trigger="visible"
      :class="{
        'w-full': true,
      }"
    >
      <ScriptGoogleMapsMarker :position="{ lat: location.lat, lng: location.lng }" />
    </ScriptGoogleMaps>
    <div
      :class="{
        'map-box bg-www-color-white px-5 py-4': true,
      }"
    >
      <h3
        :class="{
          'pb-5px text-base font-bold leading-none text-[#21303A]': true,
        }"
      >
        {{ label }}
      </h3>
      <p
        :class="{
          'pb-3 text-sm font-medium text-[#617480]': true,
        }"
      >
        {{ description }}
      </p>
      <a
        v-if="location?.lat && location?.lng"
        :href="`https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}`"
        target="_blank"
        rel="noopener noreferrer"
        :class="{
          'text-sm font-bold leading-none text-www-color-accent': true,
        }"
        >Get directions →</a
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import type { MappedLocation } from '~/sanity/types';
import { ScriptGoogleMaps, ScriptGoogleMapsMarker } from '#components';
defineProps<MappedLocation>();
</script>
